import { render, staticRenderFns } from "./AddDesignations.vue?vue&type=template&id=526b4eac&scoped=true"
import script from "./AddDesignations.vue?vue&type=script&lang=js"
export * from "./AddDesignations.vue?vue&type=script&lang=js"
import style0 from "./AddDesignations.vue?vue&type=style&index=0&id=526b4eac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526b4eac",
  null
  
)

export default component.exports